import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { themeStyle, themeStyleDark } from "../components/Components";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import {
  ContentSideBySide,
  ContentSideBySideInv,
  ThreeSideBySide,
  Hero,
  Gallery,
  Stats,
  SpacerV,
} from "../components/Hero";
import { API_URL } from "../actions/auth";
import axios from "axios";
import { useNavigate } from "react-router";
import { TypeAnimation } from "react-type-animation";
import Lottie from "react-lottie";
import {
  OurProcess,
  Advantages,
  YouWillGet,
  Collage,
  FAQ2,
  Collage2,
  Trust,
  Tailor,
} from "../components/Sections";
import { layout } from "../components/Layout";

export default function AdOperations() {
  const [news, setNews] = useState([]);
  const navigate = useNavigate();
  const state = useSelector((state) => state);
  const dark = true;
  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div
          className="anigrad"
          style={{ backgroundColor: dark ? "#111" : "white" }}
        >
          <div
            style={{
              height: state.auth.isMobile ? "130vh" : "100vh",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              width: "100vw",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                width: "75vw",
              }}
            >
              <div
                style={{
                  marginTop: state.auth.isMobile
                    ? state.auth.isTablet
                      ? "-300px"
                      : "-135px"
                    : "0px",
                  fontSize: state.auth.isMobile ? "25px" : "6vh",
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                  marginBottom: "25px",
                  fontWeight: "bold",
                }}
              >
                <div
                  style={{
                    fontSize: layout.heading2[state.auth.view],
                  }}
                >
                  Data-Driven Ad Operation Agency for Peak Performance
                </div>
              </div>
              <div
                style={{
                  fontSize: layout.textMedium[state.auth.view],
                  color: "white",
                  zIndex: 999,
                  textAlign: "left",
                }}
              >
                We administer campaigns with impact and precision to drive
                higher engagement and revenue. Our structured execution
                eliminates inefficiencies and improves ad placements for higher
                conversions and sustained performance
              </div>
              <button
                style={{
                  marginTop: "6vh",
                  filter: dark ? "invert(0)" : "invert(1)",
                }}
                onClick={() => {
                  navigate("/get-a-quote/");
                }}
                className="squishy"
              >
                Request a free estimate
              </button>
              <div
                style={{
                  display:
                    state.auth.isMobile || state.auth.view == "TABP"
                      ? "none"
                      : "block",
                }}
              >
                <Tailor
                  invert
                  title1="Tailor made"
                  subtitle1="Made with your brand in mind."
                  title2="Goal-oriented"
                  subtitle2="Made to reach business goals."
                  title3="Easy-to-Use"
                  subtitle3=" Add and edit with convenience."
                />
              </div>
            </div>
          </div>
          <Stats />
          {state.auth.isTablet ? (
            <SpacerV height={"300px"} background="#111" />
          ) : (
            ""
          )}
          <ContentSideBySide
            dark={dark}
            title={<h2>Ad Operations for Maximum Impact</h2>}
            subtitle={
              <div>
                At Riches Media Digital, we handle every aspect of ad operations
                with accuracy and strategic execution.
                <br />
                <br />
                Our team optimizes placements and monitors real-time
                performance. We also resolve technical challenges to keep
                campaigns running smoothly. We make sure that your ads deliver
                peak performance across multiple platforms.
                <br />
                <br />
                Optimize your ad operations with tailored workflows that drive
                higher returns and seamless delivery. Get started today!
              </div>
            }
            image={
              <Lottie
                options={{
                  loop: true,
                  autoplay: true,
                  animationData: require("../img/adoperations.json"),
                  rendererSettings: {
                    preserveAspectRatio: "xMidYMid slice",
                  },
                }}
                height={state.auth.isMobile ? 350 : 500}
                width={state.auth.isMobile ? 350 : 500}
                isStopped={false}
                isPaused={false}
              />
            }
          />
          <OurProcess
            process={"Our Ad Operation Process"}
            step1={"Ad Setup and Trafficking"}
            step1description={
              "We configure campaigns with precision by setting up placements and tracking parameters. Our team integrates ad creatives to match campaign objectives."
            }
            step3={"Quality Assurance and Compliance"}
            step3description={
              "We conduct thorough checks to verify that ads meet platform guidelines. Every campaign undergoes rigorous testing to prevent delivery errors and maintain consistent ad performance."
            }
            step2={"Inventory and Placement Optimization"}
            step2description={
              "We evaluate ad inventory and select placements that align with performance goals. Real-time monitoring helps us refine positioning to improve visibility and strengthen audience interaction."
            }
            step4={"Performance Monitoring and Adjustments"}
            step4description={
              "We track key performance indicators to identify optimization opportunities. Our team makes data-driven adjustments to targeting and bidding."
            }
          />
          <Advantages
            title={"Advantages of Ad Operations"}
            title1={"Efficiency & Accuracy"}
            subtitle1={
              "We streamline workflows to remove bottlenecks and enhance ad delivery. This results in seamless execution and consistent ad performance across platforms."
            }
            title2={"Real-Time Monitoring"}
            subtitle2={
              "We position ads where they generate the highest impact. Audience insights help us refine placements to increase click-through rates and conversion potential."
            }
            title3={"Optimized Performance"}
            subtitle3={
              "We monitor live performance data and adjust bidding strategies. This improves efficiency and increases return on ad spend by prioritizing high-performing placements."
            }
            title4={"Data-Driven Decisions"}
            subtitle4={
              "We manage budgets with precision and allocate resources to high-performing placements. This approach increases ROI and reduces wasted spending."
            }
          />
          <ContentSideBySideInv
            dark={dark}
            title={<h2>Ad Operations Framework That Delivers Results</h2>}
            subtitle="At Riches Media Digital, we integrate AI-driven automation with deep industry knowledge to execute high-precision ad operations. Our structured workflows eliminate inefficiencies and minimize execution errors. We analyze performance data to enhance ad placements and refine targeting strategies for measurable revenue growth. Our focus on accuracy and real-time campaign adjustments sustains peak engagement and maximizes return on ad spend."
            image={
              <img
                alt={"Ad Operation Services"}
                style={{ width: "100%", borderRadius: "25px" }}
                src={require("../img/adoperations2.jpg")}
              />
            }
          />
          <SpacerV height={"100px"} background={dark ? "#111" : "white"} />
          <YouWillGet
            willget={"What Ad Operation Services Will You Get"}
            title1={"Precision in Execution"}
            title2={"Higher ROI on Ad Spend"}
            title3={"Time-Saving Workflows"}
            title4={"Real-Time Performance Tracking"}
            title5={"Scalability for Large Campaigns"}
          />
          <div
            style={{
              display:
                state.auth.isMobile || state.auth.view == "TABP"
                  ? "none"
                  : "block",
            }}
          >
            <Trust invert />
          </div>
          <FAQ2
            q1="What are ad operations?"
            a1="Ad operations manage the setup and execution part. It also assists with the monitoring of <a href='https://richesmediadigital.com/programmatic-advertising/'>digital advertising campaigns</a>. This includes <a href='https://richesmediadigital.com/end-to-end-analytics/'> tracking ad placements</a> and making necessary adjustments to improve overall campaign performance."
            q2="Why is ad operations important?"
            a2="Ad operations ensure that <a href='https://richesmediadigital.com/programmatic-advertising/'>digital advertising campaigns</a> run smoothly. It helps brands avoid wasted ad spend and improves delivery efficiency. Businesses that invest in professional ad operations see better results and fewer technical issues that could otherwise affect their campaigns."
            q3="What platforms do you manage in ad operations?"
            a3="We deal with campaigns across search engines and social media. We also manage placements on programmatic networks and direct publisher platforms. Our team ensures that each platform follows best practices for tracking, targeting, and ad performance."
            q4="How do you monitor ad performance?"
            a4="We track key metrics such as impressions and clicks. Our team also monitors conversions and engagement data. Real-time insights help us refine targeting for continuous improvement. We provide in-depth reports that highlight strengths and improvement areas within each campaign."
            q5="How do you optimize ad placements?"
            a5="We analyze audience behavior and platform insights to select high-performing placements. This improves visibility and increases engagement rates. We also test different ad creatives and formats to determine which placements perform best and deliver the highest return."
            q6="How can ad operations improve ROI?"
            a6="Optimized workflows reduce wasted spend and improve targeting accuracy. This results in higher conversions and better returns on ad investments. Ad operations help advertisers spend smarter and achieve better results by managing bidding strategies effectively and analyzing real-time data."
          />
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
